export const QUERY_RESULTS = 'QUERY_RESULTS';
export const SINGLE_VALUE = 'single_value';
export const TEXTBOX = 'text_box';
export const PREVIEW = 'preview';

// label when collapsing long tail
export const OTHER_LABEL = 'OTHER';
